import React from 'react'
import type { Asset } from '@ztechapps/common.contract'
import { useDragSort } from '@ztechapps/webui.util'
import { useAssetPageContext, useAssetSortHandler } from './Context'
import { Item } from './item'
import styles from './GridView.module.scss'

export const GridView = () => {
  const { localListAction } = useAssetPageContext()
  const handleSort = useAssetSortHandler()
  const filteredList = localListAction.list

  const { getItemProps, getHandleProps, getContainerProps } = useDragSort<Asset>({
    items: filteredList,
    getItemKey: (asset) => asset?._id,
    onSort: handleSort,
  })

  return (
    <div className="row" {...getContainerProps()}>
      {filteredList.map((item, index) => (
        <div key={item?._id} className={`col-lg-2 col-sm-4 col-md-3 g-3 ${styles.gridItem}`} {...getItemProps(index)}>
          <Item item={item} handleProps={getHandleProps(index)} />
        </div>
      ))}
    </div>
  )
}
